import React from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { Box } from '@mui/material';

import FormFieldLabel from '../FormFieldLabel';
import { FeatureGateBanner, InputField, Select } from '../../../../../../components';
import { Switch } from '../../../../../../components/Form/components';
import staticText from '../../../../../../localization/Application/connect-playground';

const AdvancedSettings = ({
  urlValues,
  applicationMakes,
  handleChange,
  canWriteBilling,
  advancedIsGated,
  supportedCountries,
}) => {
  const advancedText = staticText.form.advanced;

  const handleInputChange = (event) => {
    const { value, name } = event.target;
    if (name === 'singleSelect') {
      handleChange({ param: name, value: event.target.checked });
      return;
    }
    handleChange({ param: name, value });
  };

  return (
    <Box display="flex" flexDirection="column" maxWidth="500px" gap={3}>
      <InputField
        label={advancedText.state.label}
        inputName="state"
        description={advancedText.state.description}
        inputValues={urlValues.state}
        inputPlaceholder={advancedText.state.placeholder}
        handleChange={handleInputChange}
        customInputWidth="500px"
      />
      <InputField
        label={advancedText.user.label}
        inputName="user"
        description={advancedText.user.description}
        inputValues={urlValues.user}
        inputPlaceholder={advancedText.user.placeholder}
        handleChange={handleInputChange}
        customInputWidth="500px"
      />
      {advancedIsGated && (
        <FeatureGateBanner
          canWriteBilling={canWriteBilling}
          upgradeText={advancedText.featureGated.upgrade}
          ownerUpgradeText={advancedText.featureGated.contactOwnersToUpgrade}
        />
      )}
      <FormFieldLabel
        label={advancedText.make.label}
        description={advancedText.make.description}
        disabled={advancedIsGated}
        tooltip={advancedText.featureGated.tooltip}
      >
        <Select
          id="make-select"
          name="make"
          options={applicationMakes.map(
            ({ make, displayName }) => ({ value: make, label: displayName }),
          )}
          value={urlValues.make || ''}
          onChange={handleInputChange}
          disabled={advancedIsGated}
          placeholderOptionLabel={advancedText.make.placeholder}
        />
      </FormFieldLabel>
      <FormFieldLabel
        label={advancedText.country.label}
        description={advancedText.country.description}
        disabled={advancedIsGated}
        tooltip={advancedText.featureGated.tooltip}
      >
        <Select
          id="country-select"
          name="country"
          options={supportedCountries.map(
            country => ({ value: country, label: country.displayName }),
          )}
          value={urlValues.country || ''}
          onChange={handleInputChange}
          disabled={advancedIsGated}
          placeholderOptionLabel={advancedText.country.placeholder}
        />
      </FormFieldLabel>
      <FormFieldLabel
        label={advancedText.singleSelect.label}
        description={advancedText.singleSelect.description}
        disabled={advancedIsGated}
        tooltip={advancedText.featureGated.tooltip}
      >
        <Switch
          name="singleSelect"
          label={advancedText.singleSelect.toggleLabel}
          checked={urlValues.singleSelect}
          onChange={handleInputChange}
          disabled={advancedIsGated}
        />
      </FormFieldLabel>
    </Box >
  );
};

export default AdvancedSettings;

AdvancedSettings.propTypes = {
  urlValues: shape({
    clientId: string.isRequired,
    state: string,
    user: string,
    make: string,
    singleSelect: bool,
  }).isRequired,
  applicationMakes: arrayOf(shape({
    make: string.isRequired,
    displayName: string.isRequired,
  })).isRequired,
  handleChange: func.isRequired,
  canWriteBilling: bool.isRequired,
  advancedIsGated: bool.isRequired,
  supportedCountries: arrayOf(string).isRequired,
};
